import { render, staticRenderFns } from "./receipt-list.vue?vue&type=template&id=509ec860&scoped=true&"
import script from "./receipt-list.vue?vue&type=script&lang=ts&"
export * from "./receipt-list.vue?vue&type=script&lang=ts&"
import style0 from "./receipt-list.vue?vue&type=style&index=0&id=509ec860&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509ec860",
  null
  
)

export default component.exports